const RESOURCES = [
  {
    id: "devfest-akure-2025-ai-driven-pm",
    title: "AI-Driven Product Management",
    description:
      "Talk from DevFest Akure 2025 on how AI is reshaping the product management craft — and where judgment, taste, and human context still matter.",
    type: "Talk",
    venue: "DevFest Akure 2025",
    source: "Google Slides",
    slideId: "1NWdI02rp_-Hhbvj6mlUnmPXb2YGazg1aN0HEXz42rrA",
    url: "https://docs.google.com/presentation/d/1NWdI02rp_-Hhbvj6mlUnmPXb2YGazg1aN0HEXz42rrA/edit?usp=sharing",
  },
  {
    id: "the-next-conversation-book-review",
    title: "Book review — The Next Conversation",
    description:
      "A working review of Jefferson Fisher's The Next Conversation: notes on how to disagree, connect, and speak with intent.",
    type: "Book review",
    venue: "Jefferson Fisher",
    source: "Google Slides",
    slideId: "127VYi-aLwqwP37EW3rsW46fz5jcRaGAFFUdUhGUTXF4",
    url: "https://docs.google.com/presentation/d/127VYi-aLwqwP37EW3rsW46fz5jcRaGAFFUdUhGUTXF4/edit?usp=sharing",
  },
  {
    id: "facility-hub-attendance-cursor",
    title: "Facility Hub — attendance backend, built with Cursor",
    description:
      "A walk-through of building the attendance feature's backend for Facility Hub with Cursor — design choices, trade-offs, and what worked.",
    type: "Build log",
    venue: "Facility Hub",
    source: "Google Slides",
    slideId: "1sFkEM3mSrRjLPF5YwX24e3mLflqbUR0jhiwJNL7RB90",
    url: "https://docs.google.com/presentation/d/1sFkEM3mSrRjLPF5YwX24e3mLflqbUR0jhiwJNL7RB90/edit?usp=sharing",
  },
];

export const thumbnailUrl = (slideId, size = 1000) =>
  `https://drive.google.com/thumbnail?id=${slideId}&sz=w${size}`;

export default RESOURCES;
